import { getCookie } from '@beef/utils';
import { endpointContent, endpoints } from "../../../../shared/api";
import { ApiHeaders, ErrorReason, ErrorScreenType } from "../../../../shared/config";
var allowedPathForRetry = [endpoints.file.download, endpoints.file.sent];
export var isAllowedPathForRetry = function isAllowedPathForRetry(url) {
  var apiHistoryVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'V5';
  var historyPath = endpoints.chat.history(apiHistoryVersion);
  if (!url) {
    return true;
  }
  return [].concat(allowedPathForRetry, [historyPath]).every(function (path) {
    return !url.includes(path);
  });
};
export var getZoneType = function getZoneType(_ref, config) {
  var authZoneConfig = _ref.authZoneConfig;
  return (authZoneConfig === null || authZoneConfig === void 0 ? void 0 : authZoneConfig.zoneType) === 'authorized' || ApiHeaders.AuthScheme in config.headers || !!Number(getCookie('isAuthorized')) ? 'authorized' : 'unauthorized';
};
export var isTriggeredErrorScreen = function isTriggeredErrorScreen(error, _ref2) {
  var _error$config, _error$response;
  var authZoneConfig = _ref2.authZoneConfig,
    apiSettings = _ref2.apiSettings;
  var historyPath = endpoints.chat.history((apiSettings === null || apiSettings === void 0 ? void 0 : apiSettings.apiHistoryVersion) || 'V5');
  var requestUrl = (_error$config = error.config) === null || _error$config === void 0 ? void 0 : _error$config.url;
  var status = ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) || 200;

  // Для падения запросов на историю / контент в обеих зонах показывваем экран ошибки
  if ((requestUrl !== null && requestUrl !== void 0 && requestUrl.includes(historyPath) || requestUrl !== null && requestUrl !== void 0 && requestUrl.includes(endpointContent((apiSettings === null || apiSettings === void 0 ? void 0 : apiSettings.apiContentVersion) || 'v1'))) && status >= 400 && status !== 401) {
    return [true, ErrorScreenType.LOAD, requestUrl !== null && requestUrl !== void 0 && requestUrl.includes(historyPath) ? ErrorReason.HISTORY_LOAD : ErrorReason.CONTENT_LOAD];
  }
  if ((authZoneConfig === null || authZoneConfig === void 0 ? void 0 : authZoneConfig.zoneType) === 'authorized') {
    return [false, undefined, undefined];
  }

  // Для падения запросов на валидацию капчи (во всех случаях кроме неудачной проверки)
  if (requestUrl !== null && requestUrl !== void 0 && requestUrl.includes(endpoints.captcha.validate) && status >= 400 && status !== 401) {
    return [true, ErrorScreenType.ERROR, ErrorReason.VALIDATE_CAPTCHA];
  }

  // Для падения запросов на рефреш токена
  if (requestUrl !== null && requestUrl !== void 0 && requestUrl.includes(endpoints.captcha.refresh) && status >= 400 && status !== 401) {
    return [true, ErrorScreenType.LOAD, ErrorReason.REFRESH_TOKEN];
  }
  return [false, undefined, undefined];
};